import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../data";

const line = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 1, delay: 0.4 + i * 0.15, ease: [0.16, 1, 0.3, 1] },
  }),
};

const Line = ({ children, i, className }) => (
  <span className="reveal-mask">
    <motion.span variants={line} custom={i} initial="hidden" animate="visible" className={`block ${className || ""}`}>
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 800], [0, 200]);
  const scale = useTransform(scrollY, [0, 800], [1, 1.15]);
  const opacity = useTransform(scrollY, [0, 500], [1, 0]);

  return (
    <section id="top" className="relative h-screen w-full overflow-hidden" data-theme="night" data-testid="hero">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={IMAGES.heroChauffeur} alt="Chauffeur opening door" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-black/70" />
      </motion.div>

      <motion.div style={{ opacity }} className="relative z-10 h-full max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col justify-center">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4, duration: 1 }}
          className="label text-gold mb-8"
        >
          Ontario — Private Chauffeur Service
        </motion.p>

        <h1 className="font-serif font-light leading-[0.95] tracking-tighter text-white text-5xl sm:text-7xl lg:text-8xl">
          <Line i={0}>Arrive not merely</Line>
          <Line i={1}>on time, but in a</Line>
          <Line i={2} className="italic text-gold">state of grace.</Line>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.6, duration: 0.9 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center"
        >
          <a
            href="#book"
            data-testid="hero-book-btn"
            className="label bg-gold text-black px-8 py-4 hover:bg-[var(--nl-gold-hover)] transition-colors duration-300 text-center"
          >
            Reserve Your Ride
          </a>
          <a
            href="#fleet"
            data-testid="hero-fleet-btn"
            className="label border border-white/20 text-white px-8 py-4 hover:border-gold hover:text-gold transition-colors duration-300 text-center"
          >
            Explore the Fleet
          </a>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-8 right-6 md:right-12 z-10 text-right"
      >
        <p className="text-white/40 text-sm max-w-[220px] font-body">
          Sedans & SUVs. Chauffeured across every city in Ontario, day and night.
        </p>
      </motion.div>
    </section>
  );
};
